export const getCategoryI18nKey = category => {
  return `marketplace-ui-common.groupTags.category.${category}`;
};
export const getTierI18nKey = tier => {
  return `marketplace-ui-common.groupTags.tier.${tier}`;
};
export const getTierHubI18nKey = hub => {
  return `marketplace-ui-common.groupTags.tierHub.${hub}`;
};
export const getTierLevelI18nKey = level => {
  return `marketplace-ui-common.groupTags.tierLevel.${level}`;
};